export function copyObject(obj: Record<any, any>) {
  return JSON.parse(JSON.stringify(obj));
}
